<template>
    <v-container fluid fill-height class="mt-5">
      存在しないルーム、もしくは時間が終了したルームです。<br>
      １０秒後にトップページに戻ります。
    </v-container>
</template>

<script>
export default {
  created () {
  	const path = this.$route.params.id
    // 無効なルームに入ろうとしたら10秒後にHomeにリダイレクト  
    setTimeout(() => {
    	if(this.$route.params.id == path)
    	{
    		document.location = "/" 
    	}
    }, 10000)
  },
}
</script>

